import { Navigate, useParams, useSearchParams } from "react-router-dom";

/**
 * An agent's settings of a module moved to the agent's own page; the old
 * links (`/settings/tools/agents/:agentId[/:toolId]`) land there.
 */
export function AgentToolRedirect() {
  const { company, agentId, toolId } = useParams<{
    company: string;
    agentId: string;
    toolId?: string;
  }>();
  const [searchParams] = useSearchParams();
  const tool = toolId || searchParams.get("tool");
  return (
    <Navigate
      replace
      to={`/${company}/agents/${agentId}${tool ? `?tool=${tool}` : ""}`}
    />
  );
}
